import { createFetcher } from '../packages/@necktip/next/api/jsonApiHandler'
import type { API } from '../pages/api/v1/[handler]'

export const apiFetcher = createFetcher<API>('/api/v1/[handler]')
